// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Wmc9","question":"Question_question__1vxtQ","description":"Question_description__3XJ8D"};